import { useEffect, useState, useRef } from 'react';
import { useStore } from 'Store';
import { StreamData, TimeInMs, PlayableModel } from 'types';
import { SeekType, ISourceTimelineEvent, ISourceTimelineEventType } from '@24i/player-base';
import { Device } from 'DeviceUtils';
import { STREAM_TYPE } from '../../../../options';

export enum AdSkipPolicy {
    NOT_SKIPPABLE = 'NOT_SKIPPABLE',
    PARTIAL_SKIPPABLE = 'PARTIAL_SKIPPABLE',
    SKIPPABLE = 'FULLY_SKIPPABLE'
}
interface FetchData {
    adBlocks?: Array<{
        adEndTimeUTC: string;
        adSkipTimeUTC?: string;
        adStartTimeUTC: string;
        id: number;
    }>;
    adSkipPolicy?: AdSkipPolicy | null;
    success: boolean;
    gracePeriodInSeconds: number;
    mediaHouse: string;
}

const timeoutTime = 5000;

export const isLive = (item: PlayableModel) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { start, end }: { start: number; end: number } = item.getMetaData().detail;
    const now = Date.now();
    return now >= start && now <= end;
};

const useAdvertisements = (item: PlayableModel, itemStreamData: StreamData) => {
    const timeoutNoResponse = useRef<NodeJS.Timeout | null>(null);
    const [adBlocks, setAdBlocks] = useState<Array<ISourceTimelineEvent> | undefined>(undefined);
    const [adSkipPolicy, setAdSkipPolicy] = useState<AdSkipPolicy | undefined>(undefined);
    const [gracePeriodInSeconds, setGracePeriodInSeconds] = useState<number | null>(null);
    const [mediaHouse, setMediaHouse] = useState<string | null>(null);

    const [disableForwardSeeking, setDisableForwardSeeking] = useState<boolean>(false);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const { start, end }: { start: number; end: number } = item.getMetaData().detail;

    const getCountedTimeInMs = (time: Date) => {
        const count =
            time.getHours() * 3600000 + time.getMinutes() * 60000 + time.getSeconds() * 1000;

        return count;
    };

    const startTime = new Date(start);
    const startTimeInMs = getCountedTimeInMs(startTime);

    const scheduleId = item?.getId();
    const { appManager } = useStore();
    const api = appManager.getApi();

    const getTimeInMs = (time: string): TimeInMs => {
        const adTime = new Date(time);

        const timeInMs = getCountedTimeInMs(adTime);
        const adTimeInMs = timeInMs - startTimeInMs;

        return isLive(item) ? adTime.getTime() : adTimeInMs;
    };

    const fetchAdvertisements = async () => {
        if (itemStreamData.streamData?.seekingForbidden) {
            try {
                const data: FetchData = await api.fetchAdSkipping(scheduleId, 3000);
                if (data && data.success) {
                    setAdSkipPolicy(data.adSkipPolicy);
                    setMediaHouse(data.mediaHouse);
                    const formatedData: Array<ISourceTimelineEvent> | undefined = data.adBlocks
                        ?.map(
                            (adItem): ISourceTimelineEvent => ({
                                type: ISourceTimelineEventType.ADVERTISEMENT,
                                start: getTimeInMs(adItem.adStartTimeUTC),
                                end: getTimeInMs(adItem.adEndTimeUTC),
                                skipOffset: getTimeInMs(
                                    adItem?.adSkipTimeUTC || adItem.adEndTimeUTC
                                ),
                                seekType: SeekType.UTC
                            })
                        )
                        .filter(Boolean);
                    if (formatedData) {
                        setAdBlocks(formatedData);
                    } else {
                        setAdBlocks([]);
                        setDisableForwardSeeking(true);
                    }

                    if (data.gracePeriodInSeconds) {
                        setGracePeriodInSeconds(data.gracePeriodInSeconds);
                    }
                    return formatedData || [];
                }
                setAdBlocks([]);
                setDisableForwardSeeking(true);
                return [];

            } catch (err) {
                setAdBlocks([]);
                setMediaHouse(null);
                setDisableForwardSeeking(true);
                return [];
            }
        } else {
            setAdBlocks([]);
            setMediaHouse(null);
            setDisableForwardSeeking(false);
            return [];
        }
    };


    const fetchAdvertisementsWithTimeout = async () => {
        const cancelTimeout = () => {
            if (timeoutNoResponse.current) {
                clearTimeout(timeoutNoResponse.current as NodeJS.Timeout);
                timeoutNoResponse.current = null;
            }
        };

        await fetchAdvertisements();
        cancelTimeout();

        if (itemStreamData.streamData?.seekingForbidden)
            timeoutNoResponse.current = setTimeout(() => {
                setAdBlocks([]);
            }, timeoutTime);

        return () => {
            if (itemStreamData.streamData?.seekingForbidden)
                clearTimeout(timeoutNoResponse.current as NodeJS.Timeout);
        };
    };

    const fetchAds = async () => {
        setAdBlocks(undefined);
        setGracePeriodInSeconds(null);
        setDisableForwardSeeking(false);
        const ads = await fetchAdvertisements();
        return ads;
    };

    // useEffect(() => {
    //     console.log('GG prehrava s');
    //     setAdBlocks(undefined);
    //     setGracePeriodInSeconds(null);
    //     setDisableForwardSeeking(false);
    //     fetchAdvertisementsWithTimeout();
    //     // setTimeout(() => {
    //     //     console.log("GG timeout")
    //     //     setAdBlocks([]);
    //     // }, 2000)
    // }, [item?.getId(), itemStreamData.streamType, itemStreamData.streamData?.seekingForbidden, itemStreamData.streamUrl]);

    return {
        adBlocks,
        setAdBlocks,
        gracePeriodInSeconds,
        setGracePeriodInSeconds,
        disableForwardSeeking,
        fetchAds,
        adSkipPolicy,
        mediaHouse
    };
};

export default useAdvertisements;
